// MAPS registry (§19.1) plus the home positions of each map's dynamic props (sugar cubes, punching
// dummies), which the generic entity step uses to respawn them (`Entity.data` = home index).
// Registry entries are getters, so a map module that (indirectly) imports this registry while it
// is still loading never observes an uninitialized binding.
import { MapId } from '../ids';
import type { Vec2 } from '../types';
import { CAKE } from './cake';
import { DUMMY_POSTS, LOBBY } from './lobby';
import type { MapDef } from './mapTypes';
import { PINBALL } from './pinball';
import { PODIUM } from './podium';
import { SPIN } from './spincycle';
import { CUBE_HOMES, TEACUP } from './teacup';

export const MAPS: Readonly<Record<MapId, MapDef>> = {
  get [MapId.LOBBY]() { return LOBBY; },
  get [MapId.PODIUM]() { return PODIUM; },
  get [MapId.TEACUP]() { return TEACUP; },
  get [MapId.PINBALL]() { return PINBALL; },
  get [MapId.CAKE]() { return CAKE; },
  get [MapId.SPIN]() { return SPIN; },
};

function propHomes(mapId: MapId): readonly Vec2[] {
  switch (mapId) {
    case MapId.LOBBY: return DUMMY_POSTS;
    case MapId.TEACUP: return CUBE_HOMES;
    default: return [];
  }
}

/** Home position of prop `index` (a CUBE or DUMMY entity's `data`) on `mapId`; the map center if unknown. */
export function propHome(mapId: MapId, index: number): Readonly<Vec2> {
  return propHomes(mapId)[index] ?? MAPS[mapId].center;
}
